import { render } from "./EditEvaluationType.vue?vue&type=template&id=73dd1682"
import script from "./EditEvaluationType.vue?vue&type=script&lang=js"
export * from "./EditEvaluationType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__